import Image from "next/image";
import { footeritems } from "@/lib/footer";
import styles from "./footerV2.module.scss";
import AccordionSingle from "@/components/accordionSingle/accordionSingle";
import Link from "next/link";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { svgImages } from "@/lib/svgImages";
import { processFooterUrl } from "@/lib/urlUtils";
import { AttributionHrefLink } from "@/components/attributionHrefLink/attributionHrefLink";

export default function FooterV2() {
  const date = new Date();
  const year = date.getFullYear();
  const [selectedId, setSelectedId] = useState(-1);
  const { t } = useTranslation();
  const [solutionsData, setSolutionsData] = useState(null);
  const [legalsData, setLegalsData] = useState(null);
  const [productsData, setProductsData] = useState(null);
  const [allImages, setAllImages] = useState(null);

  useEffect(() => {
    (async () => {
      var productData = null;

      const data = await fetch(
        "https://cms.qrhub.io/wp-json/wp/v2/solutions?per_page=100"
      ).then(
        (res) => res.json()
        // const data = await fetch("/posts.json").then((res) => res.json()
      );
      setSolutionsData(data);
      for (let index = 0; index < data.length; index++) {
        const element = data[index];

        productData = element;

        const svgData = await fetch("/images.json").then((res) => res.json());

        setAllImages(svgData);

        break;
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      var productData = null;

      const data = await fetch(
        "https://cms.qrhub.io/wp-json/wp/v2/legalPages?per_page=100"
      ).then(
        (res) => res.json()
        // const data = await fetch("/posts.json").then((res) => res.json()
      );
      setLegalsData(data);
      for (let index = 0; index < data.length; index++) {
        const element = data[index];

        productData = element;

        const svgData = await fetch("/images.json").then((res) => res.json());

        setAllImages(svgData);

        break;
      }
    })();
  }, []);

  useEffect(() => {
    (async () => {
      var productData = null;

      const data = await fetch(
        "https://cms.qrhub.io/wp-json/wp/v2/products?per_page=100"
      ).then(
        (res) => res.json()
        // const data = await fetch("/posts.json").then((res) => res.json()
      );
      setProductsData(data);
      for (let index = 0; index < data.length; index++) {
        const element = data[index];

        productData = element;

        const svgData = await fetch("/images.json").then((res) => res.json());

        setAllImages(svgData);

        break;
      }
    })();
  }, []);

  return (
    <div className={`${styles["footer"]} `} style={{ direction: "ltr" }}>
      {/* Footer For Desktop */}
      <div className="custom-container">
        <div className="inner">
          <div className={`${styles["footerTop"]}`}>
            <div className={`${styles["footerTopLeft"]}`}>
              <Link href="/en/">
                <Image
                  src="/images/qrhub-logo-icon.svg"
                  alt="QRHUB - Best Static and Dynamic QR Code Solutions"
                  width={62}
                  height={61}
                  priority
                />
              </Link>
            </div>
          </div>

          <div
            className={`${styles["footerContainerDesktop"]} d-flex-xl d-none-xs`}
          >
            {footeritems.lists &&
              footeritems.lists.map((item, index) => (
                <div
                  key={`footer-section-${index}`}
                  className={`${styles["footerSection"]}`}
                >
                  <div className={`${styles["title"]} font-size-32`}>
                    {t(item.maintitle)}
                  </div>
                  {t(item.maintitle) == "Solutions" ? (
                    <div className={`${styles["list"]}`}>
                      {solutionsData &&
                        solutionsData.map((itemLink) => (
                          <Link
                            href={`/en/solutions/${itemLink.slug}/`}
                            key={itemLink.id}
                            className={`font-size-18`}
                          >
                            {itemLink?.acf.hero_title}
                          </Link>
                        ))}
                    </div>
                  ) : t(item.maintitle) == "Legal" ? (
                    <div className={`${styles["list"]}`}>
                      {legalsData &&
                        legalsData.map((itemLink) => (
                          <Link
                            href={`/en/legal/${itemLink.slug}/`}
                            key={itemLink.id}
                            className={`font-size-18`}
                          >
                            {itemLink.title.rendered}
                          </Link>
                        ))}
                    </div>
                  ) : t(item.maintitle) == "Products" ? (
                    <div className={`${styles["list"]}`}>
                      {productsData &&
                        productsData
                          .sort((a, b) => (a.id < b.id ? -1 : 1))
                          .map((itemLink) =>
                            itemLink?.acf.isdynamic ? (
                              <Link
                                href={`/en/products/${itemLink.slug}/`}
                                key={itemLink.id}
                                className={`font-size-18`}
                              >
                                {itemLink?.acf.hero_title}
                              </Link>
                            ) : null
                          )}
                    </div>
                  ) : (
                    <div className={`${styles["list"]}`}>
                      {item.items &&
                        item.items.map((itemLink) => {
                          // Handle environment variable URLs
                          const url = processFooterUrl(itemLink.url, t);

                          // Only render link if we have a valid URL
                          if (!url) return null;

                          const isDashboardSignup =
                            itemLink.url === "dashboard_url" ||
                            (typeof url === "string" &&
                              url.includes("/account/create"));

                          if (isDashboardSignup) {
                            return (
                              <AttributionHrefLink
                                href={url}
                                key={t(itemLink.title)}
                                className={`font-size-18`}
                                {...(itemLink.openInNewTab
                                  ? {
                                      target: "_blank",
                                      rel: "noopener noreferrer",
                                    }
                                  : {})}
                              >
                                {t(itemLink.title)}
                              </AttributionHrefLink>
                            );
                          }

                          return (
                            <Link
                              href={url}
                              key={t(itemLink.title)}
                              className={`font-size-18`}
                              {...(itemLink.openInNewTab
                                ? {
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                  }
                                : {})}
                            >
                              {t(itemLink.title)}
                            </Link>
                          );
                        })}
                    </div>
                  )}
                </div>
              ))}
          </div>
          {/* Footer For small Screen */}
          <div
            className={`${styles["footerContainerMobile"]} d-none-xl d-flex-xs`}
          >
            {footeritems.lists &&
              footeritems.lists.map((item, index) => (
                <div
                  key={`footer-mobile-section-${index}`}
                  className={`${styles["footerSection"]}`}
                >
                  {t(item.maintitle) == "Solutions" ? (
                    <div className={`${styles["list"]}`}>
                      {solutionsData && (
                        <AccordionSingle
                          key={`accordion-${t(item.maintitle)}`}
                          id={index}
                          title={t(item.maintitle)}
                          description={solutionsData}
                          selectedId={selectedId}
                          setSelectedId={setSelectedId}
                          footerList={true}
                          Light="true"
                        />
                      )}
                    </div>
                  ) : t(item.maintitle) == "Legal" ? (
                    <div className={`${styles["list"]}`}>
                      {legalsData && (
                        <AccordionSingle
                          key={`accordion-${t(item.maintitle)}`}
                          id={index}
                          title={t(item.maintitle)}
                          description={legalsData}
                          selectedId={selectedId}
                          setSelectedId={setSelectedId}
                          footerList={true}
                          Light="true"
                        />
                      )}
                    </div>
                  ) : t(item.maintitle) == "Products" ? (
                    <div className={`${styles["list"]}`}>
                      {productsData && (
                        <AccordionSingle
                          key={`accordion-${t(item.maintitle)}`}
                          id={index}
                          title={t(item.maintitle)}
                          description={productsData.sort((a, b) =>
                            a.id < b.id ? -1 : 1
                          )}
                          selectedId={selectedId}
                          setSelectedId={setSelectedId}
                          footerList={true}
                          Light="true"
                        />
                      )}
                    </div>
                  ) : (
                    <div className={`${styles["list"]}`}>
                      {item.items && (
                        <AccordionSingle
                          key={`accordion-${t(item.maintitle)}`}
                          id={index}
                          title={t(item.maintitle)}
                          description={item.items.map((itemLink) => ({
                            ...itemLink,
                            url: processFooterUrl(itemLink.url, t),
                          }))}
                          selectedId={selectedId}
                          setSelectedId={setSelectedId}
                          footerList={true}
                          Light="true"
                        />
                      )}
                    </div>
                  )}
                </div>
              ))}
          </div>
        </div>
        {/* copyRight Footer */}
        <div className={`${styles["copyRightFooter"]}`}>
          <div className="inner">
            <div className={`${styles["copyRightFooterContainer"]}`}>
              <div className={`${styles["textContainer"]} font-size-18`}>
                <div className={`${styles["textContainerLeft"]} `}>
                  <span> ©</span>{" "}
                  <span className={`${styles["year"]}`}>{year}</span>{" "}
                  <Link href="/en">QRHUB</Link>
                </div>
                <div className={`${styles["text"]}`}>
                  {t(footeritems.copyright)}
                </div>
              </div>
              <div className={`${styles["socialIcons"]}`}>
                {footeritems.socialicons &&
                  footeritems.socialicons.map((item) => (
                    <Link
                      href={t(item.url)}
                      key={t(item.title)}
                      aria-label={t(item.title)}
                      target="_blank"
                      rel="noopener noreferrer No-Follow No-Referrer"
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: svgImages[t(item.title).toLowerCase()],
                        }}
                      />
                    </Link>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
